import type { ReactNode } from "react";
import { Sidebar } from "./sidebar";

interface ShellProps {
  children: ReactNode;
}

/**
 * Shell base del panel — sidebar persistente + área principal.
 *
 * v2.1: dirección estética "Anthropic Claude app meets macOS". Sin header
 * global — cada page renderiza su propio header in-page. El theme toggle
 * vive en el user menu del sidebar.
 */
export function Shell({ children }: ShellProps) {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background text-text-primary">
      <Sidebar />
      <main className="flex-1 min-w-0 min-h-0 overflow-hidden">{children}</main>
    </div>
  );
}
